import { useConfigService } from '@thd-nucleus/experience-context';
import { getUpdatedProducts } from '../utils/product-utils';
import { useDataProducts } from './useDataProducts';

export const useBundleProducts = ({ bundle }) => {
  const bundleComponents = bundle?.bundleSpecificationDetails?.components;
  const configBundleProductsDetails = useConfigService('bundleProductsDetails') || null;
  const { data, loading, error } = useDataProducts({
    itemIds: bundleComponents?.map(({ defaultProductId }) => defaultProductId),
    skip: !bundleComponents || bundleComponents.length === 0
  });

  return {
    productsData: getUpdatedProducts(data?.products, bundleComponents, configBundleProductsDetails),
    error,
    loading
  };
};
